import { Injectable } from '@angular/core';
import { ApiBaseService } from './api/api-base.service';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CommonService extends ApiBaseService {

  constructor() {
    super();
  }

  getAppVersion(): string {
    return '3.0.00';
  }

  formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return `${year}-${month}-${day} , ${hours}:${minutes}:${seconds}`;
  }

  formatDateOnly(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  formatDateValue(value: string | null | undefined, withTime: boolean = false): string {
    if (!value) return '-';
    const date = new Date(/^\d{4}-\d{2}-\d{2}$/.test(value) ? `${value}T00:00:00` : value);
    if (isNaN(date.getTime())) return '-';
    return withTime ? this.formatDate(date) : this.formatDateOnly(date);
  }

  formatDateTimeLocal(date: Date): string {
    return this.formatDate(date).replace(' , ', 'T').slice(0, 16);
  }

  downloadBase64File(base64: string, fileName: string, mimeType: string): void {
    const binary = atob(base64);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) {
      bytes[i] = binary.charCodeAt(i);
    }
    const url = URL.createObjectURL(new Blob([bytes], { type: mimeType }));
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    link.click();
    URL.revokeObjectURL(url);
  }

  getAttachments(section: any, category: any, referId:number, fileName: string, options: HttpParams): Observable<any> {
    return this.GET(this.getUrl(`/attachments/${section}/${category}/${referId}/${fileName}`), options);
  }

  isWebCryptoAvailable(): boolean {
    return !!(window.crypto && window.crypto.subtle);
  }

  async computeSha256Hex(file: File): Promise<string> {
    const buffer = await file.arrayBuffer();
    const digest = await window.crypto.subtle.digest('SHA-256', buffer);
    return Array.from(new Uint8Array(digest))
      .map(byte => byte.toString(16).padStart(2, '0'))
      .join('');
  }

}
